//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loggerLambdaComparisonQuery from '~/apollo/queries/product/logger-lambda-comparison'
import ecuLambdaComparisonQuery from '~/apollo/queries/product/ecu-lambda-comparison'

export default {
  apollo: {
    loggerLambdaComparison: {
      prefetch: true,
      query: loggerLambdaComparisonQuery
    },
    ecuLambdaComparison: {
      prefetch: true,
      query: ecuLambdaComparisonQuery
    }
  }
}
